"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignUpFailedError = exports.ResetPasswordFailedError = exports.RefreshFailedError = exports.NotLoggedInError = exports.NotImplementedError = exports.NetworkError = exports.LoginFailedError = exports.PetsAppAuth = void 0;
var errors_1 = require("./errors");
Object.defineProperty(exports, "LoginFailedError", { enumerable: true, get: function () { return errors_1.LoginFailedError; } });
Object.defineProperty(exports, "NetworkError", { enumerable: true, get: function () { return errors_1.NetworkError; } });
Object.defineProperty(exports, "NotImplementedError", { enumerable: true, get: function () { return errors_1.NotImplementedError; } });
Object.defineProperty(exports, "NotLoggedInError", { enumerable: true, get: function () { return errors_1.NotLoggedInError; } });
Object.defineProperty(exports, "RefreshFailedError", { enumerable: true, get: function () { return errors_1.RefreshFailedError; } });
Object.defineProperty(exports, "ResetPasswordFailedError", { enumerable: true, get: function () { return errors_1.ResetPasswordFailedError; } });
Object.defineProperty(exports, "SignUpFailedError", { enumerable: true, get: function () { return errors_1.SignUpFailedError; } });
var query_string_1 = __importDefault(require("query-string"));
var PetsAppAuth = /** @class */ (function () {
    function PetsAppAuth(options) {
        this.storage = options.storage;
        this.baseUrl = options.baseUrl;
        this.fetch = options.fetch;
        this.debug = options.debug;
        this.onExpire = options.onExpire;
        this.onRedirect = options.onRedirect;
        this.appId = options.appId;
        this.appUrl = options.appUrl;
    }
    PetsAppAuth.prototype.log = function (message) {
        if (this.debug) {
            console.log("(new auth client): ".concat(message));
        }
    };
    PetsAppAuth.prototype.login = function (query) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.log("Attempting to login...");
                        if (!(query.connection === "password")) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.loginEmailPassword({
                                username: query.username,
                                password: query.password,
                            })];
                    case 1:
                        _a.sent();
                        this.log("Login successful.");
                        return [2 /*return*/];
                    case 2:
                        if (!(query.connection === "google")) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.loginGoogle()];
                    case 3:
                        _a.sent();
                        this.log("Login successful.");
                        return [2 /*return*/];
                    case 4:
                        if (!(query.connection === "facebook")) return [3 /*break*/, 6];
                        return [4 /*yield*/, this.loginFacebook()];
                    case 5:
                        _a.sent();
                        this.log("Login successful.");
                        return [2 /*return*/];
                    case 6:
                        if (!(query.connection === "apple")) return [3 /*break*/, 8];
                        return [4 /*yield*/, this.loginApple()];
                    case 7:
                        _a.sent();
                        this.log("Login successful.");
                        return [2 /*return*/];
                    case 8:
                        if (!(query.connection === "oidc")) return [3 /*break*/, 10];
                        return [4 /*yield*/, this.loginOidc(query.configId)];
                    case 9:
                        _a.sent();
                        this.log("Login successful.");
                        return [2 /*return*/];
                    case 10: throw new errors_1.NotImplementedError();
                }
            });
        });
    };
    PetsAppAuth.prototype.loginGoogle = function () {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                this.log("Attempting to login with Google...");
                url = new URL("".concat(this.baseUrl, "/auth/google"));
                if (this.appUrl) {
                    url.searchParams.append("redirectUrl", this.appUrl);
                }
                if (this.onRedirect) {
                    this.log("Redirecting to Google login page");
                    this.onRedirect(url.toString());
                    return [2 /*return*/];
                }
                return [2 /*return*/];
            });
        });
    };
    PetsAppAuth.prototype.loginFacebook = function () {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                this.log("Attempting to login with Facebook...");
                url = new URL("".concat(this.baseUrl, "/auth/facebook"));
                if (this.appUrl) {
                    url.searchParams.append("redirectUrl", this.appUrl);
                }
                if (this.onRedirect) {
                    this.log("Redirecting to Facebook login page");
                    this.onRedirect(url.toString());
                    return [2 /*return*/];
                }
                return [2 /*return*/];
            });
        });
    };
    // apple is not supported on web
    PetsAppAuth.prototype.loginApple = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.log("Attempting to login with Apple...");
                if (this.onRedirect) {
                    this.log("Redirecting to Apple login page");
                    this.onRedirect("".concat(this.baseUrl, "/auth/apple"));
                    return [2 /*return*/];
                }
                return [2 /*return*/];
            });
        });
    };
    PetsAppAuth.prototype.loginOidc = function (configId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.log("Attempting to login with OIDC...");
                if (this.onRedirect) {
                    this.log("Redirecting to OIDC login page");
                    this.onRedirect(this.getOIDCLoginUrl(configId));
                    return [2 /*return*/];
                }
                return [2 /*return*/];
            });
        });
    };
    PetsAppAuth.prototype.loginEmailPassword = function (_a) {
        var username = _a.username, password = _a.password;
        return __awaiter(this, void 0, void 0, function () {
            var response, json, credentials;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.log("Attempting to login with email and password...");
                        return [4 /*yield*/, this.fetch("".concat(this.baseUrl, "/auth/login"), {
                                method: "POST",
                                headers: {
                                    "Content-Type": "application/json",
                                    "X-App-Id": this.appId || "NONE",
                                },
                                body: JSON.stringify({
                                    email: username,
                                    password: password,
                                }),
                            })];
                    case 1:
                        response = _b.sent();
                        if (!response.ok) {
                            this.log("Login failed.");
                            throw new errors_1.LoginFailedError();
                        }
                        return [4 /*yield*/, response.json()];
                    case 2:
                        json = _b.sent();
                        credentials = this.getCredentialsFromTokenResponse(json);
                        return [4 /*yield*/, this.storage.set(credentials)];
                    case 3:
                        _b.sent();
                        this.log("Login successful.");
                        return [2 /*return*/];
                }
            });
        });
    };
    PetsAppAuth.prototype.refresh = function () {
        return __awaiter(this, void 0, void 0, function () {
            var credentials, res, json, newCredentials;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.log("Attempting to refresh credentials...");
                        return [4 /*yield*/, this.storage.get()];
                    case 1:
                        credentials = _a.sent();
                        if (!credentials) {
                            this.log("Not logged in.");
                            throw new errors_1.NotLoggedInError();
                        }
                        return [4 /*yield*/, this.fetch("".concat(this.baseUrl, "/auth/refresh"), {
                                method: "POST",
                                headers: {
                                    "Content-Type": "application/json",
                                    "X-App-Id": this.appId || "NONE",
                                },
                                body: JSON.stringify({
                                    refreshToken: credentials.refreshToken,
                                }),
                            })];
                    case 2:
                        res = _a.sent();
                        if (!!res.ok) return [3 /*break*/, 4];
                        this.log("Refresh failed.");
                        return [4 /*yield*/, this.storage.clear()];
                    case 3:
                        _a.sent();
                        this.onExpire();
                        throw new errors_1.RefreshFailedError();
                    case 4: return [4 /*yield*/, res.json()];
                    case 5:
                        json = _a.sent();
                        newCredentials = this.getCredentialsFromTokenResponse(json);
                        return [4 /*yield*/, this.storage.set(newCredentials)];
                    case 6:
                        _a.sent();
                        this.log("Refresh successful.");
                        return [2 /*return*/, newCredentials];
                }
            });
        });
    };
    PetsAppAuth.prototype.logout = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.log("Attempting to logout...");
                        return [4 /*yield*/, this.storage.clear()];
                    case 1:
                        _a.sent();
                        this.log("Logout successful.");
                        return [2 /*return*/];
                }
            });
        });
    };
    PetsAppAuth.prototype.resetPassword = function (_a) {
        var email = _a.email;
        return __awaiter(this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.log("Attempting to reset password...");
                        return [4 /*yield*/, this.fetch("".concat(this.baseUrl, "/auth/forgot-password"), {
                                method: "POST",
                                headers: {
                                    "Content-Type": "application/json",
                                    "X-App-Id": this.appId || "NONE",
                                },
                                body: JSON.stringify({
                                    email: email,
                                }),
                            })];
                    case 1:
                        res = _b.sent();
                        if (!res.ok) {
                            this.log("Reset password failed.");
                            throw new errors_1.ResetPasswordFailedError();
                        }
                        this.log("Reset password successful.");
                        return [2 /*return*/];
                }
            });
        });
    };
    PetsAppAuth.prototype.checkEmailUpdateEligibility = function () {
        return __awaiter(this, void 0, void 0, function () {
            var credentials, res, json;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.log("Checking email change eligibility...");
                        return [4 /*yield*/, this.storage.get()];
                    case 1:
                        credentials = _a.sent();
                        if (!credentials) {
                            this.log("Not logged in.");
                            throw new errors_1.NotLoggedInError();
                        }
                        return [4 /*yield*/, this.fetch("".concat(this.baseUrl, "/auth/check-email-change-eligibility"), {
                                method: "POST",
                                headers: {
                                    "Content-Type": "application/json",
                                    "X-App-Id": this.appId || "NONE",
                                    "Authorization": "Bearer ".concat(credentials.accessToken)
                                }
                            })];
                    case 2:
                        res = _a.sent();
                        if (!res.ok) return [3 /*break*/, 4];
                        return [4 /*yield*/, res.json()];
                    case 3:
                        json = _a.sent();
                        this.log("Email change eligibility retrieved");
                        return [2 /*return*/, json];
                    case 4:
                        this.log("Unable to fetch email change eligibility");
                        throw new errors_1.NetworkError(res.status, res.statusText);
                }
            });
        });
    };
    PetsAppAuth.prototype.initiateEmailChange = function (_a) {
        var email = _a.email;
        return __awaiter(this, void 0, void 0, function () {
            var credentials, res, json;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.log("Initiating email update...");
                        return [4 /*yield*/, this.storage.get()];
                    case 1:
                        credentials = _b.sent();
                        if (!credentials) {
                            this.log("Not logged in.");
                            throw new errors_1.NotLoggedInError();
                        }
                        return [4 /*yield*/, this.fetch("".concat(this.baseUrl, "/auth/change-email"), {
                                method: "POST",
                                headers: {
                                    'Accept': 'application/json',
                                    'Content-Type': 'application/json',
                                    "X-App-Id": this.appId || "NONE",
                                    "Authorization": "Bearer ".concat(credentials.accessToken)
                                },
                                body: JSON.stringify({
                                    newEmail: email,
                                }),
                            })];
                    case 2:
                        res = _b.sent();
                        return [4 /*yield*/, res.json()];
                    case 3:
                        json = _b.sent();
                        if (json) {
                            return [2 /*return*/, json];
                        }
                        else {
                            this.log("Unable to update email address");
                            throw new errors_1.NetworkError(res.status, res.statusText);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    PetsAppAuth.prototype.getCredentialsFromTokenResponse = function (json) {
        var expiresInMsWithErrorMargin = (json.expires_in - 30) * 1000;
        var expiresAt = Date.now() + expiresInMsWithErrorMargin;
        return {
            refreshToken: json.refresh_token,
            accessToken: json.access_token,
            expiresAt: expiresAt,
        };
    };
    PetsAppAuth.prototype.saveCredentials = function (rawResponse) {
        return __awaiter(this, void 0, void 0, function () {
            var credentials;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        credentials = this.getCredentialsFromTokenResponse(rawResponse);
                        return [4 /*yield*/, this.storage.set(credentials)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    PetsAppAuth.prototype.signUp = function (_a) {
        var email = _a.email, password = _a.password, firstName = _a.firstName, lastName = _a.lastName, locale = _a.locale;
        return __awaiter(this, void 0, void 0, function () {
            var res, json, credentials;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.log("Attempting to sign up...");
                        return [4 /*yield*/, this.fetch("".concat(this.baseUrl, "/auth/register"), {
                                method: "POST",
                                headers: {
                                    "Content-Type": "application/json",
                                    "X-App-Id": this.appId || "NONE",
                                },
                                body: JSON.stringify({
                                    email: email,
                                    password: password,
                                    firstName: firstName,
                                    lastName: lastName,
                                    locale: locale,
                                }),
                            })];
                    case 1:
                        res = _b.sent();
                        if (!res.ok) {
                            this.log("Sign up failed.");
                            throw new errors_1.SignUpFailedError();
                        }
                        return [4 /*yield*/, res.json()];
                    case 2:
                        json = _b.sent();
                        if (json === null || json === void 0 ? void 0 : json.forgot_password_flow) {
                            return [2 /*return*/, json];
                        }
                        credentials = this.getCredentialsFromTokenResponse(json);
                        return [4 /*yield*/, this.storage.set(credentials)];
                    case 3:
                        _b.sent();
                        this.log("Sign up successful.");
                        return [2 /*return*/];
                }
            });
        });
    };
    PetsAppAuth.prototype.accessToken = function (_a) {
        var forceRefresh = _a.forceRefresh;
        return __awaiter(this, void 0, void 0, function () {
            var credentials, newCredentials;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.log("Attempting to get access token...");
                        return [4 /*yield*/, this.storage.get()];
                    case 1:
                        credentials = _b.sent();
                        if (!credentials) {
                            this.log("Not logged in.");
                            throw new errors_1.NotLoggedInError();
                        }
                        if (!(forceRefresh || credentials.expiresAt < Date.now())) return [3 /*break*/, 3];
                        this.log("Refreshing access token...");
                        return [4 /*yield*/, this.refresh()];
                    case 2:
                        newCredentials = _b.sent();
                        this.log("Access token refreshed.");
                        return [2 /*return*/, newCredentials.accessToken];
                    case 3:
                        this.log("Access token retrieved.");
                        return [2 /*return*/, credentials.accessToken];
                }
            });
        });
    };
    PetsAppAuth.prototype.getMethodsForEmail = function (email) {
        return __awaiter(this, void 0, void 0, function () {
            var res, json;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.log("Attempting to get methods for email...");
                        return [4 /*yield*/, this.fetch("".concat(this.baseUrl, "/auth/methods"), {
                                method: "POST",
                                headers: {
                                    "Content-Type": "application/json",
                                    "X-App-Id": this.appId || "NONE",
                                },
                                body: JSON.stringify({ email: email }),
                            })];
                    case 1:
                        res = _a.sent();
                        if (!res.ok) return [3 /*break*/, 3];
                        return [4 /*yield*/, res.json()];
                    case 2:
                        json = _a.sent();
                        this.log("Methods for email retrieved.");
                        return [2 /*return*/, json];
                    case 3:
                        this.log("Failed to get methods for email.");
                        throw new errors_1.NetworkError(res.status, res.statusText);
                }
            });
        });
    };
    PetsAppAuth.prototype.getOIDCLoginUrl = function (configId) {
        var url = new URL("".concat(this.baseUrl, "/auth/oidc/").concat(configId));
        if (this.appUrl) {
            url.searchParams.append("redirectUrl", this.appUrl);
        }
        return url.toString();
    };
    PetsAppAuth.prototype.getGoogleLoginUrl = function () {
        var url = new URL("".concat(this.baseUrl, "/auth/google"));
        if (this.appUrl) {
            url.searchParams.append("redirectUrl", this.appUrl);
        }
        return url.toString();
    };
    PetsAppAuth.prototype.getFacebookLoginUrl = function () {
        var url = new URL("".concat(this.baseUrl, "/auth/facebook"));
        if (this.appUrl) {
            url.searchParams.append("redirectUrl", this.appUrl);
        }
        return url.toString();
    };
    PetsAppAuth.prototype.persistCredentialsFromUrl = function (url) {
        return __awaiter(this, void 0, void 0, function () {
            var parsedUrl, accessToken, refreshToken, expiresIn, credentials;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        parsedUrl = query_string_1.default.parseUrl(url);
                        accessToken = parsedUrl.query["access_token"];
                        refreshToken = parsedUrl.query["refresh_token"];
                        expiresIn = parsedUrl.query["expires_in"];
                        if (typeof accessToken !== "string" ||
                            typeof refreshToken !== "string" ||
                            typeof expiresIn !== "string") {
                            this.log("Wrong URL params");
                            return [2 /*return*/, false];
                        }
                        this.log("Checking URL for credentials");
                        if (!(accessToken && refreshToken && expiresIn)) return [3 /*break*/, 3];
                        this.log("Checking if we have credentials already");
                        return [4 /*yield*/, this.storage.get()];
                    case 1:
                        credentials = _a.sent();
                        if (!!credentials) return [3 /*break*/, 3];
                        this.log("Saving credentials from URL");
                        return [4 /*yield*/, this.saveCredentials({
                                access_token: accessToken,
                                refresh_token: refreshToken,
                                expires_in: parseInt(expiresIn),
                            })];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, true];
                    case 3: return [2 /*return*/, false];
                }
            });
        });
    };
    PetsAppAuth.prototype.getSSOFeatures = function () {
        return __awaiter(this, void 0, void 0, function () {
            var res, json;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.log("Attempting to get SSO features...");
                        return [4 /*yield*/, this.fetch("".concat(this.baseUrl, "/auth/features"), {
                                method: "GET",
                                headers: {
                                    "Content-Type": "application/json",
                                    "X-App-Id": this.appId || "NONE",
                                },
                            })];
                    case 1:
                        res = _a.sent();
                        if (!res.ok) return [3 /*break*/, 3];
                        return [4 /*yield*/, res.json()];
                    case 2:
                        json = _a.sent();
                        this.log("SSO features retrieved.");
                        return [2 /*return*/, json];
                    case 3:
                        this.log("Failed to get SSO features.");
                        throw new errors_1.NetworkError(res.status, res.statusText);
                }
            });
        });
    };
    return PetsAppAuth;
}());
exports.PetsAppAuth = PetsAppAuth;
